import React from "react";
import { withStyles, withTheme } from "@material-ui/core/styles";
import { ITheme } from "../Layout/themes";
import { Paper, IconButton, Typography } from "@material-ui/core";
import { Text } from "../Ui/Text";
import CloseIcon from "@material-ui/icons/Close";

const styles = ({ palette, typography, breakpoints }: ITheme) => ({
  paper: {
    padding: "16px 20px",
    width: 424,
    [breakpoints.down("sm")]: {
      width: "85vw",
      height: "100vh"
    }
  },
  headingContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    borderBottom: "1px solid rgba(0,0,0,0.1)"
  },
  headingText: {
    lineHeight: 1,
    fontSize: 15,
    fontWeight: 600,
    color: "#18171b"
  },
  closeIconBtn: {
    marginRight: -12,
    marginTop: -12
  },
  closeIcon: {
    color: palette.primary.main
  },
  bodyContainer: {
    marginTop: 12
  },
  bodyText: {
    color: palette.text.secondary
  },
  descriptionText: {
    fontSize: 16
  },
  list: {
    marginTop: 29,
    listStyle: "none",
    margin: 0,
    padding: 0
  },
  listItem: {
    display: "flex",
    marginBottom: 20
  },
  listNumberText: {
    fontSize: 30,
    fontWeight: 700,
    marginRight: 12,
    color: palette.text.secondary,
    [breakpoints.down("sm")]: {
      fontSize: 25
    }
  },
  listText: {
    color: "#191919",
    fontSize: 18,
    [breakpoints.down("sm")]: {
      fontSize: 16
    }
  }
});

interface IProps {
  classes: any;
  closeModal: () => void;
}

class ModalContentComponent extends React.Component<IProps> {
  render() {
    const { classes, closeModal } = this.props;
    return (
      <Paper className={classes.paper}>
        <div className={classes.headingContainer}>
          <Text variant="body1" className={classes.headingText}>
            How it works
          </Text>
          <IconButton
            aria-label="delete"
            onClick={closeModal}
            className={classes.closeIconBtn}
            data-testid="testIconBtn"
          >
            <CloseIcon className={classes.closeIcon} data-testid="icon" />
          </IconButton>
        </div>
        <div className={classes.bodyContainer}>
          <Text variant="body2" className={classes.bodyText}>
            Securely share tickets with your friends.
          </Text>

          <ul className={classes.list}>
            <li className={classes.listItem}>
              <Text variant="h4" className={classes.listNumberText}>
                1.
              </Text>
              <Text variant="body1" className={classes.listText}>
                Enter the email or mobile number of your friend. They'll be
                asked to sign in to their Ticketek account to accept the ticket.
              </Text>
            </li>
            <li className={classes.listItem}>
              <Text variant="h4" className={classes.listNumberText}>
                2.
              </Text>
              <Text variant="body1" className={classes.listText}>
                You can cancel or recall the ticket share at any time.
              </Text>
            </li>
            <li className={classes.listItem}>
              <Text variant="h4" className={classes.listNumberText}>
                3.
              </Text>
              <Text variant="body1" className={classes.listText}>
                Track the status of the ticket at any time in Order History. For
                more tips on Ticket Sharing visit our FAQ
              </Text>
            </li>
          </ul>
        </div>
      </Paper>
    );
  }
}

export const ModalContent = withTheme(
  withStyles(styles)(ModalContentComponent)
);
